import * as angular from 'angular';
import { IHtmlMailService } from '../../services';
import { ContextualField, EventEmailDefinition, ConnectionPointType } from '../../models';
import * as Fields from '../../common/helpers/contextual';

export interface IEditSendMailActionService {
    getProperties(): ContextualField[];
    send(mail: EventEmailDefinition): angular.IPromise<void>;
}

export class EditSendMailActionService implements IEditSendMailActionService {
    static serviceId = 'editSendMailActionService';

    static $inject = ['htmlMailService'];

    constructor(
        private _htmlMailService: IHtmlMailService
    ) {
    }

    getProperties(): ContextualField[] {
        const connectionPointGuid = Object.assign({}, Fields.ConnectionPointGuid);
        connectionPointGuid.extraData = {
            types: [ConnectionPointType.SMTP],
            subProperty: 'emailDefinition'
        };
        const isSingleDashboardFile = angular.copy(Fields.IsSingleDashboardFile);
        isSingleDashboardFile.extraData = { subProperty: 'emailDefinition' };

        const properties: ContextualField[] = [
            angular.copy(Fields.Name),
            angular.copy(Fields.IsDisabledField),
            connectionPointGuid,
            angular.copy(Fields.DateFormat),
            isSingleDashboardFile
        ];
        return properties;
    }

    // for backward compat
    send(mail: EventEmailDefinition) {
        return this._htmlMailService.send(mail);
    }
}